import React, { useContext, useMemo } from "react";

import { Box, IconOnePass, List } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

import { Shop } from "@header/types";

import { ONEPASS_ITEM_SLUG } from "../../../consts";
import { MenuItem } from "../../../MenuItem";
import { MobileMenuContext } from "../../../MobileMenuContext";
import { ActiveIdPath, TransformedShop } from "../../../types";

import { CatchEssentialsMenu } from "./CatchEssentialsMenu";

const OnePassItem = styled(MenuItem)`
  margin: 0px;
  a,
  a:hover,
  a:focus {
    color: white;

    svg {
      color: white;
    }
  }

  li {
    display: flex;
    align-items: center;
    height: 48px;
    background-color: ${(props) => themeGet("colors.onePass.primary")(props)};
    padding-left: 15px;
    margin-bottom: 0px;
  }
`;

export const getCategoriesMenu = (menu: Shop[]): TransformedShop[] => {
  const seasonalMenu = [...menu]
    .filter((menuItem) => menuItem.pinToTop)
    .sort((prev, next) => (prev.url === "/" ? -1 : next.url === "/" ? 1 : 0))
    .sort((prev, next) =>
      prev.slug === ONEPASS_ITEM_SLUG
        ? -1
        : next.slug === ONEPASS_ITEM_SLUG
        ? 1
        : 0
    );

  const categoryMenu = menu.filter((menuItem) => !menuItem.pinToTop);

  return [...seasonalMenu, ...categoryMenu].map((menuItem, index) => ({
    ...menuItem,
    position: index + 1,
  }));
};

export type CategoriesMenuProps = {
  onItemClick: (idPath: ActiveIdPath) => void;
};

export const CategoriesMenu = ({
  onItemClick,
  ...props
}: CategoriesMenuProps) => {
  const { shops = [] } = useContext(MobileMenuContext);
  const categoriesMenu = useMemo<TransformedShop[]>(
    () => getCategoriesMenu(shops),
    [shops]
  );

  return (
    <Box as="nav" overflowY="scroll" {...props}>
      <List my="0px">
        {categoriesMenu.map((menuItem) => {
          const isOnePass = menuItem.slug === ONEPASS_ITEM_SLUG;
          return isOnePass ? (
            <OnePassItem
              aria-label="OnePass"
              key={`${menuItem.name}-${menuItem.position}`}
              url={menuItem.url}
              itemPath={[
                {
                  name: menuItem.name,
                  id: menuItem.id,
                  position: menuItem.position,
                },
              ]}
            >
              <IconOnePass width="72px" height="15px" />
            </OnePassItem>
          ) : (
            <MenuItem
              key={`${menuItem.name}-${menuItem.position}`}
              url={menuItem.url}
              hasChildren={menuItem.shopNavigationGroups.length > 0}
              itemPath={[
                {
                  name: menuItem.name,
                  id: menuItem.id,
                  position: menuItem.position,
                },
              ]}
              onClick={() => onItemClick([menuItem.id])}
            >
              {menuItem.name}
            </MenuItem>
          );
        })}
      </List>
      <CatchEssentialsMenu startIndex={categoriesMenu.length} />
    </Box>
  );
};
